export default {
  /*-------------Mobile Verification API START----------*/
  MN_VERIFICATION_OTP: "adaptor/plugin/video-kyc/user-verification/generate-otp",
  MN_RESEND_OTP: "adaptor/plugin/video-kyc/user-verification/resend-otp",
  MN_VERIFY_OTP: "adaptor/plugin/video-kyc/user-verification/submit-otp",
  /*-------------Mobile Verification API END----------*/

  GET_CURRENT_STATE: "adaptor/plugin/video-kyc",
  // PAN_VERIFICATION: "adaptor/plugin/video-kyc/pan-verification",
  GET_CAPTCHA: "adaptor/plugin/video-kyc/aadhaar-captcha",
  GET_OTP: "adaptor/plugin/video-kyc/aadhaar-otp",
  GENERATE_EKYC_AADHAAR_OTP: "adaptor/plugin/video-kyc/ekyc-generate-otp",
  SUBMIT_OTP: "adaptor/plugin/video-kyc/submit-otp",
  VALIDATE_EKYC_AADHAAR_OTP: "adaptor/plugin/video-kyc/ekyc-validate-otp",
  GET_VIDEO_LINK: "adaptor/plugin/video-kyc/new-user-link",
  CONSENT_FORM: "adaptor/plugin/video-kyc/consent-form",
  UPDATE_KYC_TYPE: "adaptor/plugin/video-kyc/type",

  POA: "adaptor/plugin/video-kyc/poa",
  POI_PHOTO: "adaptor/plugin/video-kyc/poi-photo",
  AADHAAR_XML_CONFIRM: "adaptor/plugin/video-kyc/aadhaar-user-confirmation",
  SAVE_USER_LOCATION: "adaptor/plugin/video-kyc/user-location",
  CHECK_PHOTO_LIVENESS: "adaptor/plugin/video-kyc/photo-liveness",
  CKYC_ADDRESS_CONFIRM: "adaptor/plugin/video-kyc/address-confirmation",
  PAN_VERIFICATION: "adaptor/plugin/video-kyc/pan-verification-v2",
  SEARCH_CKYC: "adaptor/plugin/video-kyc/search-ckyc",
  GENERATE_AADHAAR_OTP: "adaptor/plugin/video-kyc/generate-aadhaar-otp",
  SUBMIT_AADHAAR_OTP: "adaptor/plugin/video-kyc/submit-aadhaar-otp",
  QUICK_KYC_GENERATE_OTP: "adaptor/plugin/video-kyc/customer/generate-otp",
  QUICK_KYC_VALIDATE_OTP: "adaptor/plugin/video-kyc/customer/validate-otp",
  QUICK_KYC_VERIFY: "adaptor/plugin/video-kyc/customer/check-details",
  USER_ADDITIONAL_DETAILS: "adaptor/plugin/video-kyc/customer-additional-detail",
  CREATE_CIF: "adaptor/plugin/video-kyc/bank-verification",
  PENNY_DROP: "adaptor/plugin/video-kyc/penny-drop",
  FETCH_META_FIELDS: "adaptor/plugin/video-kyc/fetch-metafields-config",
  SET_META_FIELDS: "adaptor/plugin/video-kyc/set-metafields",
  USER_PAN_NAME: "adaptor/plugin/video-kyc/user-pan-name",

  /*-------------HDFC BANK API START----------*/
  HDFC_VKYC_ADDITIONAL_DETAILS: "adaptor/plugin/video-kyc/user-additional-details",
  HDFC_VKYC_USER_DETAILS: "adaptor/plugin/video-kyc/show-user-details",
  HDFC_EKYC: "adaptor/plugin/video-kyc/ekyc",
  HDFC_COMPLETED_STEPS: "adaptor/plugin/video-kyc/completed-steps",
  HDFC_VKYC_ADDRESS_CONFIRMATION: "adaptor/plugin/video-kyc/aadhaar-address-confirmation",
  CONSENT_FORM_LANGUAGE: "adaptor/plugin/video-kyc/consent-form-language",
  HDFC_VKYC: "adaptor/plugin/video-kyc/vkyc",
  HDFC_VKYC_PAN_VERIFICATION: "adaptor/plugin/video-kyc/vkyc/pan-verification",
  /*-------------HDFC BANK API END----------*/
};
